import { IAssetMetadata } from "../..";
import { MediaType } from "../../../types";
import { PexelsVideoItem, PexelsVideoFile } from "../types";
import { BasePexelsAsset, deriveVideoName } from "./base";

const VIDEO_QUALITY_ORDER: PexelsVideoFile['quality'][] = ['hd' , 'sd'];

function getBestResolution(videos: PexelsVideoFile[]): PexelsVideoFile | undefined {
  for (const key of VIDEO_QUALITY_ORDER) {
    const video = videos.find(v => v.quality === key);
    if (video) return video;
  }
  return undefined;
}

export class VideoAsset extends BasePexelsAsset {
  private item: PexelsVideoItem;

  constructor(item: PexelsVideoItem) {
    super(item.id, item.url);
    this.item = item;
  }

  getName(): string {
    return deriveVideoName(this.item.url);
  }

  getMediaType(): MediaType {
    return MediaType.Video;
  }

  getImageUrlForCard(): string {
    return this.item.video_pictures[0]?.picture ?? '';
  }

  getPreviewUrl(): string {
    return getBestResolution(this.item.video_files)?.link ?? '';
  }

  getDownloadUrl(): string {
    return getBestResolution(this.item.video_files)?.link ?? '';
  }

  async downloadFile(): Promise<{ blob: Blob; filename: string }> {
    const url = this.getDownloadUrl();
    if (!url) throw new Error('No downloadable video URL available');
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Failed to download Pexels video: ${response.statusText}`);
    const blob = await response.blob();
    const ext = url.split('.').pop()?.split('?')[0] ?? 'mp4';
    return { blob, filename: `${this.getName()}.${ext}` };
  }

  getMetadata(): IAssetMetadata {
    return {
      status: 'ready',
      date: '',
      size: 0, // Pexels API doesn't provide file size in the search response
      licence: 'Pexels-licence',
      licenceUrl: 'https://www.pexels.com/license/',
      author: this.item.user.name,
      tags: [],
      categories: [],
    };
  }
}
